import { useEffect, useState } from "react";

import { transferAmountValidation } from "../../../../utils/helper";

interface TransferValidationProps {
  value: number;
  maxAmount: number;
}

const useTransferAmountValidation = (props: TransferValidationProps) => {
  const { value, maxAmount } = props;

  const [error, setError] = useState<string>("");

  const validateTransfer = (value: number, maxAmount: number) => {
    setError(transferAmountValidation(value, maxAmount));
  };

  useEffect(() => {
    validateTransfer(value, maxAmount);
  }, [value, maxAmount]);

  return error;
};

export default useTransferAmountValidation;
